<router-outlet></router-outlet>
<app-toast></app-toast>
<app-session-revoked-modal></app-session-revoked-modal>
<app-account-inactive-modal [isOpen]="(authService.accountInactive$ | async)?.isOpen ?? false"
    [disabledDate]="(authService.accountInactive$ | async)?.date"
    (backToLogin)="authService.closeAccountInactiveModal()">
</app-account-inactive-modal>
<app-token-expiration-modal 
    [isOpen]="(modalState$ | async)?.isOpen ?? false"
    [timeRemaining]="(modalState$ | async)?.timeRemaining ?? defaultWarningDuration"
    [sessionExpired]="(modalState$ | async)?.sessionExpired ?? false"
    (continueSession)="onContinueSession()"
    (logoutNow)="onLogoutNow()">
</app-token-expiration-modal>